import {
  AccessLevelEntityType,
  getAccessLevelDescription,
} from "@components/access-level/access-level-utils";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/faro-dialog";
import { AccessLevelDisplayNames } from "@components/access-level/access-level-utils";
import { Alert, Dialog, Text } from "@flat-ui";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

interface Props {
  /** Type of the entity to which the access level belongs, it is used in the access level descriptions */
  type: AccessLevelEntityType;

  /** The new access level to confirm */
  accessLevel: FaroCoreApiTypes.ProjectAccessLevel;

  /** Whether the dialog is open */
  isOpen: boolean;

  /** Whether the confirm action is in progress */
  isLoading: boolean;

  /** Callback when the user confirms the change */
  onConfirm: () => void;

  /** Callback when the user closes the dialog */
  onClose: () => void;
}

/** Confirmation dialog for changing project access level */
export function ChangeAccessLevelConfirmDialog({
  type,
  accessLevel,
  isOpen,
  isLoading,
  onConfirm,
  onClose,
}: Props): JSX.Element {
  return (
    <Dialog
      title="Change access level"
      open={isOpen}
      onCancel={onClose}
      confirmText="Change"
      onConfirm={onConfirm}
      showSpinner={isLoading}
      disabled={isLoading}
    >
      <Text variant="bodyL">
        Are you sure you want to change the access level to{" "}
        <strong>{AccessLevelDisplayNames[accessLevel]}</strong>?
      </Text>

      <Alert
        variant="info"
        title={getAccessLevelDescription(type, accessLevel)}
        sx={{ mt: SPACE_ELEMENTS_OF_MODAL }}
      />
    </Dialog>
  );
}
